import type { VaultDataMap } from "@stepfinance/vaults";
import { useQuery } from "@tanstack/react-query";

import { STEP_API_ENDPOINT } from "../../utils/swr";
import { fetchJSONFromUrl } from "../../utils/utils";
import { queryConfig } from "./queryConfig";

const initialData: VaultDataMap = {
  tulipVaults: {
    Orca: {},
    Raydium: {},
    Saber: {},
  },
  kaminoVaults: {
    onChainData: {},
    offChainData: {},
  },
  tulipStrategyVaults: {
    aprData: {
      rates: [],
    },
    vaultData: [],
  },
  psyFiVaults: {},
};

export const useVaultsQuery = () => {
  return useQuery(["vaults", "data"], fetchVaults, {
    ...queryConfig,
    initialData,
  });
};

const fetchVaults = async (): Promise<VaultDataMap> => {
  return await fetchJSONFromUrl<VaultDataMap>(`${STEP_API_ENDPOINT}/v1/integration/vaults`);
};
